import gql from 'graphql-tag'

export default gql`
  mutation updateRole($id: Int!, $name: String!, $description: String, $permissions: [PermissionInput]) {
    updateRole(id: $id, name: $name, description: $description, permissions: $permissions) {
      id
      name
      slug
      description
      permissions {
        id      
      }
  }
}
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/role/update.js